import { Component, OnInit } from '@angular/core';
import { GenericItem, GenericItemCls, GenericListComponent } from 'octali-lib-utils';

@Component({
  selector: 'app-category-span-item',
  templateUrl: './category-span-item.component.html',
  styleUrls: ['./category-span-item.component.scss'],
})
export class CategorySpanItemComponent implements OnInit, GenericItemCls {

  constructor() { }
  parent: GenericListComponent;
  datas: any;
  options: any;

  click(): void {
    this.parent.addSelected(this.datas.id);
  }

  isSelected(): boolean {
    return this.parent.isSelected( this.datas.id );
  }

  ngOnInit() {
    
  }

}
